import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    email,
    firstName,
    lastName,
    role,
} = constantsData.forms.users.user;

const {
    email: emailFieldName,
    firstName: firstNameFieldName,
    lastName: lastNameFieldName,
    role: roleFieldName,
} = formFieldNamesData;

export const userFormData = [
    {
        fields: [
            {
                isMini: true,
                label: firstName.label,
                name: firstNameFieldName,
                type: InputTypeEnum.TEXT,
            },
            {
                isMini: true,
                label: lastName.label,
                name: lastNameFieldName,
                type: InputTypeEnum.TEXT,
            },
        ],
        isRowGroup: true,
    },
    {
        isDisabled: true,
        label: email.label,
        name: emailFieldName,
        type: InputTypeEnum.EMAIL,
    },
    {
        description: role.description,
        hasOptionFormat: true,
        label: role.label,
        name: roleFieldName,
        options: optionsData.roles,
        type: FieldTypeEnum.SELECT,
    },
];
